"use client"

import type React from "react"

interface ErrorScreenProps {
  title: string
  message: string
  onRetry?: () => void
  onGoBack?: () => void
}

const ErrorScreen: React.FC<ErrorScreenProps> = ({ title, message, onRetry, onGoBack }) => (
  <div className="error-screen">
    <div className="error-content">
      <div className="error-icon">⚠️</div>
      <h2>{title}</h2>
      <p>{message}</p>
      <div className="error-actions">
        {onRetry && (
          <button className="retry-button" onClick={onRetry}>
            Try Again
          </button>
        )}
        {onGoBack && (
          <button className="back-button" onClick={onGoBack}>
            Go Back
          </button>
        )}
      </div>
    </div>
  </div>
)

export default ErrorScreen
